import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { expenseToComponentMap, IPlannedExpenseValuesType, useGetPlannedExpenseOptions } from './utils/form';
import { FinancialPlanChipSelector } from '../components/FinancialPlanChipSelector';
import { ActiveTabContextProvider, useTabChangeContext } from '../hooks/useTabChangeContext';

export const PlannedExpensesContent: FC = () => {
  const { t } = useTranslation();

  const { activeTab, onTabChange } = useTabChangeContext();
  const PLANNED_EXPENSE_OPTIONS = useGetPlannedExpenseOptions();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES,
  );

  const Component = expenseToComponentMap[activeTab.value as IPlannedExpenseValuesType];

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.plannedExpenses.title')}
        />
      </FormSectionCard>

      <FinancialPlanChipSelector options={PLANNED_EXPENSE_OPTIONS} selected={activeTab} onChange={onTabChange} />

      <Component />
    </>
  );
};

export const PlannedExpenses: FC = () => {
  const PLANNED_EXPENSE_OPTIONS = useGetPlannedExpenseOptions();
  return (
    <ActiveTabContextProvider initialValue={PLANNED_EXPENSE_OPTIONS[0]}>
      <PlannedExpensesContent />
    </ActiveTabContextProvider>
  );
};
